<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-28 10:25:40
-->
<template>
  <div class="component--nude-layout full flex-col" style="overflow-y: auto">
    <HeaderPart
      :is-show-menu="false"
      :portraitVisible="false"
      :exitable="false"
      size="small"
      :is-show-logo="true"
    >
    </HeaderPart>

    <!-- 页面容器 -->
    <div
      class="innerContent container body-content flex-col flex-expend"
      style="overflow-y: auto"
    >
      <router-view class="page-container"></router-view>
    </div>

    <FootPart></FootPart>
  </div>
</template>

<script>
import HeaderPart from "./components/Header";
import FootPart from "./components/Foot";

export default {
  components: {
    HeaderPart,
    FootPart,
  },
};
</script>

<style lang="scss">
.component--nude-layout {
  background-color: #e5e5e5;

  .innerContent {
    position: relative;
  }

  .page-container {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: 0.2s;
    padding: 18px;
  }

  .btn_close:hover {
    opacity: 0.7;
  }
}
</style>